import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="gothic-footer">
      <div className="footer-noise-overlay"></div>
      
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          <div className="footer-section footer-brand">
            <div className="footer-logo">
              <h2 className="logo-text">MAACKIA'S CULT</h2>
              <div className="logo-underline"></div>
            </div>
            <p className="footer-tagline">
              Underground thrift finds for the alternative soul
            </p>
            <div className="social-links">
              <a href="https://www.instagram.com/maackias_cult/" className="social-link" aria-label="Instagram">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a href="#" className="social-link" aria-label="TikTok">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-.88-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
              <a href="#" className="social-link" aria-label="Discord">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03z"/>
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">CULT CATEGORIES</h3>
            <div className="footer-divider"></div>
            <ul className="footer-links">
              <li><a href="#" className="footer-link">Gothic & Dark</a></li>
              <li><a href="#" className="footer-link">Punk Rock Tees</a></li>
              <li><a href="#" className="footer-link">Grunge Essentials</a></li>
              <li><a href="#" className="footer-link">Alternative Accessories</a></li>
              <li><a href="#" className="footer-link">Rare Band Merch</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">DARK SUPPORT</h3>
            <div className="footer-divider"></div>
            <ul className="footer-links">
              <li><a href="#" className="footer-link">Contact the Cult</a></li>
              <li><a href="#" className="footer-link">Sizing Guide</a></li>
              <li><a href="#" className="footer-link">Return Ritual</a></li>
              <li><a href="#" className="footer-link">FAQ</a></li>
              <li><a href="#" className="footer-link">Track Your Order</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">JOIN THE DARKNESS</h3>
            <div className="footer-divider"></div>
            <p className="newsletter-text">Get notified of new underground finds</p>
            <div className="newsletter-form">
              <input 
                type="email" 
                placeholder="Your email address..." 
                className="newsletter-input"
              />
              <button className="newsletter-btn">
                <span>SUBSCRIBE</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            <div className="cult-badges">
              <div className="cult-badge">
                <span className="badge-icon">🔥</span>
                <span>Curated Finds</span>
              </div>
              <div className="cult-badge">
                <span className="badge-icon">💀</span>
                <span>Authentic Pieces</span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; 2025 Thrift Cult. All rights reserved to the underground.</p>
            </div>
            <div className="footer-bottom-links">
              <a href="#" className="bottom-link">Privacy Policy</a>
              <span className="divider">|</span>
              <a href="#" className="bottom-link">Terms of Service</a>
              <span className="divider">|</span>
              <a href="#" className="bottom-link">Cookie Policy</a>
            </div>
          </div>
          <div className="footer-decoration">
            <div className="decoration-line"></div>
            <div className="decoration-symbol">✦</div>
            <div className="decoration-line"></div>
          </div>
        </div>
      </div>

      {/* Floating elements for atmosphere */}
      <div className="floating-elements">
        <div className="floating-cross">✚</div>
        <div className="floating-star">✦</div>
        <div className="floating-cross floating-cross-2">✚</div>
      </div>
    </footer>
  );
};

export default Footer;